import { connect } from "react-redux";
import pl_PL from "../../translations/pl_PL";
import en_GB from "../../translations/en_GB";
import { Image } from "react-native";

const TImage = (props) => {
  const languageSwitcher = (languageCode) => {
    switch (languageCode) {
      case "en_GB":
        return en_GB;
      case "pl_PL":
        return pl_PL;
      // case 'de_DE':
      //     return de_DE;
      // case 'gr_GR':
      //     return gr_GR;
      default:
        return en_GB;
    }
  };

  return (
    <Image
      resizeMode="contain"
      style={props.styles.image}
      source={languageSwitcher(props.language)[props.children]}
    />
  );
};

export default connect((store) => ({
  language: store.language,
}))(TImage);
